module.exports = __webpack_public_path__ + "img/donutcharticon-active.83ec8a4e.png";